import { DialogActions } from '@material-ui/core';

import { bind } from 'bind-decorator';

import { Button, FlatButton } from 'bz-core-controls';

import type { IBaseProps } from 'bz-core-controls/modal-new/confirmation';
import React from 'react';

export interface IProps extends Pick<IBaseProps, 'actionProps'> {
  className: string;

  onYes: () => void;
  onNo: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  abortLabel?: string;
  cancelLabel?: string;
}

class YesNoActions extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    actionProps: {
      confirmLabel: '',
      abortLabel: '',
      cancelLabel: ''
    }
  };
  render() {
    const { actionProps, className } = this.props;
    const { confirmLabel, abortLabel, cancelLabel } = actionProps;
    const confirm = !!confirmLabel ? confirmLabel : 'Yes';
    const abort = !!abortLabel ? abortLabel : 'No';
    const cancel = !!cancelLabel ? cancelLabel : 'Cancel';
    return (
      <DialogActions {...actionProps} className={`${className} actions`}>
        <FlatButton
          className={`${className} btn-yes`}
          label={cancel}
          secondary={false}
          onClick={this.onCancel}
          key="cancel"
        />
        <FlatButton
          className={`${className} btn-no`}
          label={abort}
          secondary={true}
          onClick={this.onNo}
        />
        <Button
          className={`${className} btn-cancel`}
          label={confirm}
          primary={true}
          onClick={this.onYes}
        />
      </DialogActions>
    );
  }

  @bind
  private onYes(e: React.MouseEvent<any>): void {
    this.props.onYes();
  }

  @bind
  private onNo(e: React.MouseEvent<any>): void {
    this.props.onNo();
  }

  @bind
  private onCancel(e: React.MouseEvent<any>): void {
    this.props.onCancel();
  }
}

export default YesNoActions;
